import React from "react";
import FormWrapper from "../../ServeToThrive/shared/FormWrapper";
import ProgressBar from "../../ServeToThrive/shared/ProgressBar";

const denominationOptions = [
  { value: "anglican", label: "Anglican / Church of England" },
  { value: "baptist", label: "Baptist" },
  { value: "catholic", label: "Catholic" },
  { value: "charismatic", label: "Charismatic" },
  { value: "evangelical", label: "Evangelical" },
  { value: "methodist", label: "Methodist" },
  { value: "pentecostal", label: "Pentecostal" },
  { value: "presbyterian", label: "Presbyterian" },
  { value: "reformed", label: "Reformed" },
  { value: "non-denominational", label: "Non-denominational" },
  { value: "other", label: "Other" },
];

const inputStyle = {
  width: "100%", padding: "12px 16px", fontSize: "16px", color: "#1a1a1a",
  backgroundColor: "#fff", border: "1px solid #e5e5e5", borderRadius: "8px",
  outline: "none", transition: "all 0.2s ease", boxSizing: "border-box",
};

export default function ChurchAffiliation({ formData, onInputChange, onContinue, onBack, stepNumber, totalSteps }) {
  const isAffiliated = formData.churchAffiliation === "affiliated";

  const focusStyle = (e) => { e.currentTarget.style.borderColor = "#1a1a1a"; e.currentTarget.style.boxShadow = "0 0 0 3px rgba(26,26,26,0.05)"; };
  const blurStyle = (e) => { e.currentTarget.style.borderColor = "#e5e5e5"; e.currentTarget.style.boxShadow = "none"; };

  return (
    <FormWrapper>
      <button onClick={onBack} style={{ display: "flex", alignItems: "center", gap: "6px", padding: "8px 12px", fontSize: "14px", fontWeight: "500", color: "#737373", backgroundColor: "transparent", border: "none", cursor: "pointer", marginBottom: "8px" }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#1a1a1a")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#737373")}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
        Back
      </button>

      <ProgressBar currentStep={stepNumber} totalSteps={totalSteps} />

      <div style={{ textAlign: "center", marginBottom: "32px", animation: "fadeInUp 0.5s ease" }}>
        <div style={{ width: "48px", height: "48px", backgroundColor: "#f3f4f6", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", border: "1px solid #e5e7eb" }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#36454F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" /><path d="M9 21v-4h6v4" />
          </svg>
        </div>
        <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1a1a1a", marginBottom: "8px", letterSpacing: "-0.5px" }}>Church connection</h1>
        <p style={{ fontSize: "15px", color: "#737373", margin: 0 }}>Are you connected to a local church?</p>
      </div>

      {/* Toggle */}
      <div style={{ display: "flex", gap: "12px", marginBottom: "32px", animation: "fadeInUp 0.5s ease 0.1s both" }}>
        {[
          { val: "affiliated", label: "Yes, I'm part of a church", icon: <><path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" /><path d="M9 21v-4h6v4" /></> },
          { val: "independent", label: "I'm not currently part of a church", icon: <><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></> },
        ].map(({ val, label, icon }) => {
          const active = formData.churchAffiliation === val;
          return (
            <button key={val} onClick={() => onInputChange("churchAffiliation", val)}
              style={{ flex: 1, padding: "16px 12px", fontSize: "14px", fontWeight: "600", color: active ? "#fff" : "#525252", backgroundColor: active ? "#1a1a1a" : "#fff", border: active ? "1px solid #1a1a1a" : "1px solid #e5e5e5", borderRadius: "8px", cursor: "pointer", transition: "all 0.2s ease", display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}
              onMouseEnter={(e) => { if (!active) e.currentTarget.style.borderColor = "#1a1a1a"; }}
              onMouseLeave={(e) => { if (!active) e.currentTarget.style.borderColor = "#e5e5e5"; }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">{icon}</svg>
              {label}
            </button>
          );
        })}
      </div>

      {/* Church details */}
      {isAffiliated && (
        <div style={{ animation: "fadeInUp 0.3s ease" }}>
          {[
            { field: "churchName", label: "Church name", placeholder: "Which church are you part of?" },
            { field: "churchCity", label: "Church location", placeholder: "City or town" },
          ].map(({ field, label, placeholder }) => (
            <div key={field} style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#1a1a1a", marginBottom: "8px" }}>{label}</label>
              <input type="text" value={formData[field] || ""} onChange={(e) => onInputChange(field, e.target.value)}
                placeholder={placeholder} style={inputStyle} onFocus={focusStyle} onBlur={blurStyle} />
            </div>
          ))}

          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#1a1a1a", marginBottom: "8px" }}>Denomination</label>
            <select value={formData.denomination || ""} onChange={(e) => onInputChange("denomination", e.target.value)}
              style={{ ...inputStyle, color: formData.denomination ? "#1a1a1a" : "#a3a3a3", cursor: "pointer" }}
              onFocus={focusStyle} onBlur={blurStyle}>
              <option value="">Select denomination...</option>
              {denominationOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>

          <div style={{ marginBottom: "32px" }}>
            <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#1a1a1a", marginBottom: "8px" }}>Your role at church</label>
            <input type="text" value={formData.churchRole || ""} onChange={(e) => onInputChange("churchRole", e.target.value)}
              placeholder="E.g., Pastor, Worship Leader, Elder, Member..." style={inputStyle} onFocus={focusStyle} onBlur={blurStyle} />
            <p style={{ fontSize: "13px", color: "#a3a3a3", marginTop: "8px" }}>This helps verify your connection to the church community</p>
          </div>
        </div>
      )}

      {!isAffiliated && (
        <div style={{ padding: "20px", backgroundColor: "#f3f4f6", borderRadius: "8px", marginBottom: "32px", textAlign: "center", border: "1px solid #e5e7eb", animation: "fadeInUp 0.3s ease" }}>
          <p style={{ fontSize: "14px", color: "#36454F", margin: 0, fontWeight: "500" }}>
            No problem! You can still participate on Collavo.
          </p>
        </div>
      )}

      <button onClick={onContinue}
        style={{ width: "100%", padding: "16px 24px", fontSize: "16px", fontWeight: "600", color: "#fff", backgroundColor: "#1a1a1a", border: "none", borderRadius: "8px", cursor: "pointer", transition: "all 0.2s ease", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#333"; e.currentTarget.style.transform = "translateY(-1px)"; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#1a1a1a"; e.currentTarget.style.transform = "translateY(0)"; }}>
        Continue
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
      </button>
    </FormWrapper>
  );
}
